<template>
    <v-container class="grey lighten-5" fluid>
        <v-row>
            <!-- Transaction ID -->
            <v-col md="2">
                <v-text-field 
                    v-model="search.reference"
                    append-icon="mdi-magnify"
                    label="Reference"
                    class="mt-0 pt-0"
                    v-on:keyup.enter="searchClient"
                ></v-text-field>
            </v-col>

            <!-- First Name -->
            <v-col md="2">
                <v-text-field 
                    v-model="search.firstName"
                    append-icon="mdi-magnify"
                    label="First Name"
                    class="mt-0 pt-0"
                    v-on:keyup.enter="searchClient"
                ></v-text-field>
            </v-col>

            <!-- Surname -->
            <v-col md="2">
                <v-text-field 
                    v-model="search.surname"
                    append-icon="mdi-magnify"
                    label="Surname"
                    class="mt-0 pt-0"
                    v-on:keydown.enter="searchClient"
                ></v-text-field>
            </v-col>

            <!-- Mobile -->
            <v-col md="2">
                <v-text-field 
                    v-model="search.mobile"
                    append-icon="mdi-magnify"
                    label="Mobile"
                    class="mt-0 pt-0"
                    v-on:keydown.enter="searchClient"
                ></v-text-field>
            </v-col>

            <!-- Email -->
            <v-col md="2">
                <v-text-field 
                    v-model="search.email"
                    append-icon="mdi-magnify"
                    label="Email"
                    class="mt-0 pt-0"
                    v-on:keydown.enter="searchClient"
                ></v-text-field>
            </v-col>

            <!-- Postcode -->
            <v-col md="2">
                <v-text-field 
                    v-model="search.postcode"
                    append-icon="mdi-magnify"
                    label="Postcode"
                    class="mt-0 pt-0"
                    v-on:keydown.enter="searchClient"
                ></v-text-field>
            </v-col>
        </v-row>

        <v-row>
            <v-col md="12">
                <v-data-table
                    :headers="headers"
                    :items="clients"
                    :items-per-page="10"
                    class="elevation-1"
                    :loading="loading"
                >
                <template v-slot:item.info="{ item }">
                    <v-btn text icon color="primary">
                        <router-link :to="`/client/${item.id}`">
                            <v-icon color="primary" size="22">
                                mdi-account
                            </v-icon>
                        </router-link>
                    </v-btn>
                </template>

                <template v-slot:item.mobile="{ item }">
                    {{ mobileCheck(item.mobile) }}
                </template>
                </v-data-table>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
import axios from 'axios';

export default {
    beforeMount() {
        this.getClients();
    },
    data() {
        return {
            search: { reference: null,
                      company: null,
                      firstName: null,
                      surname: null,
                      mobile: null,
                      email: null,
                      postcode: null },
            headers: [{ text: 'Account', value: 'info', sortable: false, align: 'left' },
                      { text: 'Company', value: 'merchantName', sortable: false, align: 'left' },
                      { text: 'Reference', value: 'merchantCustomerId', sortable: false, align: 'left' },
                      { text: 'First Name', value: 'firstName', sortable: false, align: 'left' },
                      { text: 'Surname', value: 'surname', sortable: false, align: 'left' },
                      { text: 'Mobile', value: 'mobile', sortable: false, align: 'left' },
                      { text: 'Email', value: 'email', sortable: false, align: 'left' },
                      { text: 'Postcode', value: 'postcode', sortable: false, align: 'left' }],
            clients: [],
            merchants: null,
            loading: false
        }
    },
    methods: {
        getClients() {
            if(this.$store.state.user.user_role.id <= 3) {
                axios({
                method: 'get',
                url: `get-all-clients`,
                config: { headers: { 'Content-Type': 'application/x-www-form-urlencoded' }}
                })
                .then(response => {
                    // this.clients = response.data;
                })
                .catch(e => {
                    this.errors.push(e)
                })
            }
            else if(this.$store.state.user.user_role.id > 3) {

                if(this.$store.state.user.merchant_access_test) {
                    this.merchants = JSON.parse(this.$store.state.user.merchant_access_test).concat(JSON.parse(this.$store.state.user.merchant_access));
                }
                else {
                    this.merchants = JSON.parse(this.$store.state.user.merchant_access);
                }

                axios({
                method: 'post',
                url: `get-clients-live-client`,
                data: { userId: this.$store.state.user.id, merchants: this.merchants },
                config: { headers: { 'Content-Type': 'application/x-www-form-urlencoded' }}
                })
                .then(response => {
                    this.clients = response.data;
                })
                .catch(e => {
                    this.errors.push(e)
                })
            }
        },
        searchClient() {
            this.loading = true;
            if(this.$store.state.user.user_role.id <= 3) {
                axios({
                method: 'post',
                url: `search-client`,
                data: { client: this.search },
                config: { headers: { 'Content-Type': 'application/x-www-form-urlencoded' }}
                })
                .then(response => {
                    this.clients = response.data;
                    this.loading = false;
                })
                .catch(e => {
                    this.errors.push(e)
                })
            }
            else if(this.$store.state.user.user_role.id > 3) {
                axios({
                method: 'post',
                url: `search-client-client`,
                data: { client: this.search, merchants: this.merchants },
                config: { headers: { 'Content-Type': 'application/x-www-form-urlencoded' }}
                })
                .then(response => {
                    this.clients = response.data;
                    this.loading = false;
                })
                .catch(e => {
                    this.errors.push(e)
                })
            }
        },
        mobileCheck(mobile) {
            if(mobile) {
                return mobile;
            }
            else {
                return '';
            }
        }
    }
}
</script>

<style>
    button a {
        color: inherit !important;
        text-decoration: none;
    }


</style>